import Typography from '@mui/material/Typography';

const CustomSubheader = props => {
  const {children} = props;
  return (
    <Typography variant='h2' color='text.blue' lineHeight='normal' letterSpacing='0.65px'>
      {children}
    </Typography>
  );
};

export default CustomSubheader;
